import { FrameName } from "../config";
import AbstractRiverTerrainTileEntity from "./AbstractRiverTerrainTileEntity";

class River9TerrainTileEntity extends AbstractRiverTerrainTileEntity {
	public static readonly frameName = FrameName.RIVER9;
}

export default River9TerrainTileEntity;
